import { z } from "zod"
import {
  actorAssertionIdSchema,
  commandIdSchema,
  correlationIdSchema,
  identityIdSchema,
  membershipIdSchema,
  tenantIdSchema,
} from "./identifiers.js"

export const ACTOR_ASSERTION_ISSUER = "impetusos-bff"
export const ACTOR_ASSERTION_MAX_LIFETIME_SECONDS = 60

const siteNameSchema = z.string().regex(
  /^(?=.{1,253}$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/,
  "Site name must be a canonical lowercase hostname."
)

export const actorAssertionClaimsV1Schema = z
  .object({
    version: z.literal(1),
    iss: z.literal(ACTOR_ASSERTION_ISSUER),
    aud: z.string(),
    site: siteNameSchema,
    tenantId: tenantIdSchema,
    identityId: identityIdSchema,
    membershipId: membershipIdSchema,
    commandId: commandIdSchema,
    correlationId: correlationIdSchema,
    jti: actorAssertionIdSchema,
    iat: z.number().int().nonnegative().safe(),
    exp: z.number().int().positive().safe(),
  })
  .strict()
  .superRefine((claims, refinement) => {
    if (claims.aud !== `impetusos-frappe:${claims.site}`) {
      refinement.addIssue({ code: "custom", path: ["aud"], message: "Audience must bind the site." })
    }
    if (claims.exp <= claims.iat || claims.exp - claims.iat > ACTOR_ASSERTION_MAX_LIFETIME_SECONDS) {
      refinement.addIssue({ code: "custom", path: ["exp"], message: "Assertion lifetime is invalid." })
    }
  })

export type ActorAssertionClaimsV1 = z.infer<typeof actorAssertionClaimsV1Schema>

export interface ExpectedActorContextV1 {
  version: 1
  site: string
  tenantId: ActorAssertionClaimsV1["tenantId"]
  identityId: ActorAssertionClaimsV1["identityId"]
  membershipId: ActorAssertionClaimsV1["membershipId"]
  commandId: ActorAssertionClaimsV1["commandId"]
  correlationId: ActorAssertionClaimsV1["correlationId"]
}
